import React from "react";
import { Link } from "react-router-dom";

function Aboutnew() {
  return (
    <>
      <section className="section-sp1 about-area animate__animated animate__fadeIn">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mb-30 abt-left-column">
              <div className="about-thumb-area">
                <img
                  src="/assets/images/about_1.jpg"
                  className="about-thumb2"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-6 mb-30 abt-right-column">
              <div className="heading-bx">
                {/* <h6 className="title-ext text-secondary top_subhead">About Us</h6> */}
                <h2 className="title_section2">
                  About <br /> Bioversal Remedies
                </h2>
				 
                <p className="justify mt-3 lh-base">
  <a href="https://www.bioversalremedies.com/">Bioversal Remedies</a>, a premium
  unit of healthcare &amp; well-being, is a focused{" "}
  <strong>
    <a href="https://curasiamedilabs.com/pharma-franchise/">Pharma Franchise</a>
  </strong>{" "}
  and one of the leading suppliers and third party manufacturers of various
  medicines, including ayurvedic products, injectables, skincare products,
  pediatric products, antibiotics, syrups, antispasmodic tablets, etc. Being a{" "}
  <strong>
    <a href="https://biostempharma.com/pcd-pharma-companies/">
      PCD Pharma company
    </a>
  </strong>{" "}
  our products are highly sought after by our customers due to their superior
  quality, authenticity, and consistent composition. These product lines are
  widely employed in the healthcare field. Our pledges motivate us to achieve
  higher standards of success because we place our patients’ best interests at
  the forefront of all we do.
</p>



              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Aboutnew;
